import { gql } from "@apollo/client";

export const STREAM_CANCEL = gql`
  mutation streamCancel($id: Int!) {
    streamCancel(id: $id) {
      id
      message
      isError
    }
  }
`;
